import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import api from '../services/api';

const GOLD = '#B8892A';
const INK = '#18140C';
const INK3 = '#7A7268';
const MUTED = '#685840';
const BG = '#FAF8F5';
const BD = '#E8E0D0';
const GRN = '#2E7D4F';

const CATEGORIES = [
  { key: 'suggestion', label: '功能建议' },
  { key: 'bug', label: '问题反馈' },
  { key: 'complaint', label: '投诉' },
  { key: 'other', label: '其他' },
];
const STATUS_LABEL = { new: '待处理', read: '已查看', resolved: '已处理' };

export default function Feedback() {
  const [category, setCategory] = useState('suggestion');
  const [content, setContent] = useState('');
  const [contact, setContact] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [mine, setMine] = useState([]);

  const loadMine = () => {
    api.get('/feedback/mine').then(({ data }) => setMine(data.data || [])).catch(() => {});
  };
  useEffect(() => { loadMine(); }, []);

  const submit = async () => {
    const text = content.trim();
    if (!text) { message.warning('请填写反馈内容'); return; }
    setSubmitting(true);
    try {
      await api.post('/feedback', { content: text, category, contact: contact.trim() });
      message.success('感谢您的反馈！');
      setContent(''); setContact('');
      loadMine();
    } catch (e) {
      message.error(e.response?.data?.error || '提交失败');
    } finally { setSubmitting(false); }
  };

  return (
    <div style={{ background: BG, minHeight: '100vh', padding: '20px 16px 40px', fontFamily: 'var(--sans,sans-serif)' }}>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: INK, marginBottom: 4 }}>意见反馈</h2>
        <p style={{ fontSize: 12, color: INK3, marginBottom: 18 }}>您的建议是我们改进的动力，我们会认真查看每一条反馈</p>

        <div style={{ background: '#fff', border: `1px solid ${BD}`, borderRadius: 12, padding: 16 }}>
          {/* 分类 */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
            {CATEGORIES.map(c => (
              <button key={c.key} onClick={() => setCategory(c.key)} style={{
                padding: '6px 14px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                border: `1px solid ${category === c.key ? GOLD : BD}`,
                background: category === c.key ? `${GOLD}12` : '#fff',
                color: category === c.key ? GOLD : MUTED, fontWeight: category === c.key ? 600 : 400,
              }}>{c.label}</button>
            ))}
          </div>

          <textarea
            value={content} onChange={e => setContent(e.target.value)} maxLength={2000}
            placeholder="请描述您遇到的问题或建议…"
            style={{
              width: '100%', minHeight: 120, padding: 12, border: `1px solid ${BD}`, borderRadius: 8,
              fontSize: 14, color: INK, outline: 'none', boxSizing: 'border-box', resize: 'vertical',
              fontFamily: 'inherit',
            }}
          />
          <div style={{ textAlign: 'right', fontSize: 11, color: INK3, marginTop: 4 }}>{content.length}/2000</div>

          <input
            value={contact} onChange={e => setContact(e.target.value)} maxLength={128}
            placeholder="联系方式（选填，便于回复）"
            style={{
              width: '100%', padding: '10px 12px', border: `1px solid ${BD}`, borderRadius: 8,
              fontSize: 14, color: INK, outline: 'none', boxSizing: 'border-box', marginTop: 10,
            }}
          />

          <button onClick={submit} disabled={submitting} style={{
            width: '100%', marginTop: 16, padding: 13, borderRadius: 10, border: 'none',
            background: submitting ? '#ccc' : GOLD, color: '#fff', fontSize: 15, fontWeight: 600,
            cursor: submitting ? 'not-allowed' : 'pointer',
          }}>{submitting ? '提交中…' : '提交反馈'}</button>
        </div>

        {/* 我的反馈记录 */}
        {mine.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: INK, marginBottom: 10 }}>我的反馈</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {mine.map(f => (
                <div key={f.id} style={{ background: '#fff', border: `1px solid ${BD}`, borderRadius: 10, padding: '12px 14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                    <span style={{ fontSize: 12, color: GOLD, fontWeight: 600 }}>
                      {(CATEGORIES.find(c => c.key === f.category) || {}).label || '反馈'}
                    </span>
                    <span style={{ fontSize: 11, color: f.status === 'resolved' ? GRN : INK3 }}>
                      {STATUS_LABEL[f.status] || f.status}
                    </span>
                  </div>
                  <div style={{ fontSize: 13, color: INK, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{f.content}</div>
                  <div style={{ fontSize: 11, color: INK3, marginTop: 6 }}>{new Date(f.created_at).toLocaleString('zh-CN')}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
